import colors from "./colors";

export default colors("1f77b4ff7f0e2ca02cd627289467bd8c564be377c27f7f7fbcbd2217becf");



//////////////////
// WEBPACK FOOTER
// /srv/scratch/old-home/dyall/trinity/trinity-frontend-master/~/d3-scale/src/category10.js
// module id = ../../../../d3-scale/src/category10.js
// module chunks = 3